import React, { useState, useContext, useEffect, useRef } from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";
import Fields from "./Fields";

const doesNothing = () => {};

const getFormData = (form) => {
  const data = new FormData(form);
  return Object.fromEntries(data.entries());
};

const CreateClient = ({
  others = [],
  doSave = doesNothing,
  doValidate = doesNothing,
}) => {
  const actions = useContext(ActionsContext);
  const [open, setOpen] = useState(false);
  const doClose = () => setOpen(false);
  const [error, setError] = useState(null);
  const form = useRef(null);

  useEffect(() => {
    actions.recv("new-client-radius", () => setOpen(true));
  }, []);

  if(!open) {
    return null;
  }

  const handleChange = () => {
    try {
      const currently = getFormData(form.current);
      doValidate(currently);
      setError(null);
    } catch (error) {
      setError(error);
    }
  };

  const doApply = () => {
    try {
      const currently = getFormData(form.current);
      doSave(currently);
      doClose();
    } catch (error) {
      setError(error);
    }
  };

  return (
    <Modal
      title="Create Client"
      superIcon="add_circle"
      large={false}
      content={() => (
        <form ref={form}>
          <Fields onChange={handleChange} />
        </form>
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={error !== null}
      closeLabel="CANCEL"
      onClose={doClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};

export default CreateClient;
